import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../utils/numberFormatter';
import { getCurrency } from '../../../utils/utils';
import { Variant } from '../../../models/Product';

export const CollectionProductNetPrice: React.FC<{
    variant: Variant;
}> = (props) => {
    const { variant } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    return (
        <Box sx={{ textAlign: 'right' }}>
            <Typography sx={{ fontWeight: 'bold' }}>
                {t('PRODUCT.NET')}
            </Typography>
            {variant.compareAtPrice && (
                <Typography
                    sx={{
                        textDecoration: 'line-through',
                        fontWeight: 'bold',
                    }}
                >
                    {formatPrice(variant.compareAtPrice.amount / 1.27)}{' '}
                    {getCurrency(variant.compareAtPrice.currencyCode)}
                </Typography>
            )}
            <Typography sx={{ fontWeight: 'bold', color: '#007cb0' }}>
                {formatPrice(variant.price.amount / 1.27)}{' '}
                {getCurrency(variant.price.currencyCode)}
            </Typography>
        </Box>
    );
};
